import React from "react";
import PropTypes from "prop-types";
import { InputField, RadioField } from "../../FormField";
import moment from "moment";

const Part1 = ({ data }) => (
  <table
    style={{
      margin: "10px 0px",
      width: "100%",
      borderCollapse: "collapse",
      border: "1px solid #000",
    }}
  >
    <tbody>
      <tr>
        <td
          style={{
            fontWeight: "bold",
            backgroundColor: "#edb8be",
            paddingLeft: 10,
            borderBottom: "1px solid #000",
          }}
        >
          I)&nbsp;&nbsp;PARTICULARS of the EMPLOYEE/ELIGIBLE MEMBER
        </td>
      </tr>
      <tr>
        <td style={{ paddingBottom: 5, border: "1px solid #000" }}>
          <table style={{ width: "100%" }}>
            <tbody>
              <tr>
                <td style={{ paddingLeft: 10, width: 20 }}>a.</td>
                <td>Name (According to NRIC/Passport)</td>
              </tr>
              <tr>
                <td>&nbsp;</td>
                <td style={{ borderBottom: "1px solid #000" }} id="RO_EmployeeName">
                  <InputField name="EmployeeName" {...data["EmployeeName"]} />
                </td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
      <tr>
        <td style={{ border: "1px solid #000" }}>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <tbody>
              <tr>
                <td
                  style={{
                    width: "50%",
                    borderRight: "1px solid #000",
                    paddingBottom: 5,
                  }}
                >
                  <table style={{ width: "100%" }}>
                    <tbody>
                      <tr>
                        <td style={{ paddingLeft: 10, width: 20 }}>b.</td>
                        <td>
                          NRIC/Passport
                          <sup>*</sup> Number
                        </td>
                      </tr>
                      <tr>
                        <td>&nbsp;</td>
                        <td style={{ borderBottom: "1px solid #000" }} id="RO_Identification">
                          <InputField name="Identification" {...data["Identification"]} />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
                <td>
                  <table style={{ width: "100%" }}>
                    <tbody>
                      <tr>
                        <td
                          style={{
                            paddingLeft: 10,
                            width: 20,
                            paddingBottom: 5,
                          }}
                        >
                          c.
                        </td>
                        <td>Nationality</td>
                      </tr>
                      <tr>
                        <td>&nbsp;</td>
                        <td style={{ paddingBottom: 5 }}>
                          <InputField
                            name="Nationality"
                            {...data["Nationality"]}
                            style={{ width: "200px" }}
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
      <tr>
        <td style={{ paddingBottom: 5, border: "1px solid #000" }}>
          <table style={{ width: "100%" }}>
            <tbody>
              <tr>
                <td style={{ paddingLeft: 10, width: 20 }}>d.</td>
                <td>Occupation</td>
              </tr>
              <tr>
                <td>&nbsp;</td>
                <td>
                  <InputField name="JobTitle" {...data["JobTitle"]} style={{ width: "500px" }} />
                </td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
      <tr>
        <td style={{ paddingBottom: 5, border: "1px solid #000" }}>
          <table style={{ width: "100%" }}>
            <tbody>
              <tr>
                <td style={{ paddingLeft: 10, width: 20 }}>e.</td>
                <td>Email Address (in current company)</td>
              </tr>
              <tr>
                <td>&nbsp;</td>
                <td>
                  <InputField
                    name="EmailAddress"
                    {...data["EmailAddress"]}
                    style={{ width: "500px" }}
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
      <tr>
        <td style={{ border: "1px solid #000" }}>
          <table style={{ borderCollapse: "collapse", width: "initial" }}>
            <tbody>
              <tr>
                <td
                  style={{
                    width: "25%",
                    borderRight: "1px solid #000",
                    paddingBottom: 5,
                    paddingRight: 20,
                  }}
                >
                  <table style={{ width: "100%" }}>
                    <tbody>
                      <tr>
                        <td style={{ paddingLeft: 10, width: 20 }}>f.</td>
                      </tr>
                      <tr>
                        <td style={{ paddingLeft: 10, paddingBottom: 5 }}>
                          <table style={{ width: "100%" }}>
                            <tbody>
                              <tr>
                                <td>Male</td>
                                <td>
                                  <RadioField
                                    name="Gender"
                                    {...data["Gender"]}
                                    style={{ marginTop: "-5px" }}
                                    radioValue="Male"
                                  />
                                </td>
                                <td style={{ width: 30 }} />
                                <td>Female</td>
                                <td>
                                  <RadioField
                                    name="Gender"
                                    {...data["Gender"]}
                                    style={{ marginTop: "-5px" }}
                                    radioValue="Female"
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td>Single</td>
                                <td>
                                  <RadioField
                                    name="MaritalStatus"
                                    {...data["MaritalStatus"]}
                                    style={{ marginTop: "-5px" }}
                                    radioValue="Single"
                                  />
                                </td>
                                <td style={{ width: 30 }} />
                                <td>Married</td>
                                <td>
                                  <RadioField
                                    name="MaritalStatus"
                                    {...data["MaritalStatus"]}
                                    style={{ marginTop: "-5px" }}
                                    radioValue="Married"
                                  />
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
                <td
                  style={{
                    width: "25%",
                    borderRight: "1px solid #000",
                    paddingBottom: 5,
                    paddingRight: 20,
                  }}
                >
                  <table style={{ width: "100%" }}>
                    <tbody>
                      <tr>
                        <td style={{ paddingLeft: 10, width: 20 }}>g.</td>
                        <td>Date of Birth</td>
                      </tr>
                      <tr>
                        <td>&nbsp;</td>
                        <td style={{ paddingBottom: 5 }}>
                          <table
                            style={{
                              width: "100%",
                              border: "1px solid #000",
                              borderCollapse: "collapse",
                            }}
                          >
                            <tbody>
                              <tr>
                                <td
                                  style={{
                                    textAlign: "center",
                                    border: "1px solid #000",
                                  }}
                                >
                                  Day
                                </td>
                                <td
                                  style={{
                                    textAlign: "center",
                                    border: "1px solid #000",
                                  }}
                                >
                                  Month
                                </td>
                                <td
                                  style={{
                                    textAlign: "center",
                                    border: "1px solid #000",
                                  }}
                                >
                                  Year
                                </td>
                              </tr>
                              <tr>
                                <td
                                  style={{
                                    textAlign: "center",
                                    border: "1px solid #000",
                                  }}
                                  id="RO_BirthDateDay"
                                >
                                  <InputField
                                    name="BirthDateDay"
                                    {...data["BirthDateDay"]}
                                    type="number"
                                    max="31"
                                    style={{ width: "40px", textAlign: "center" }}
                                  />
                                </td>
                                <td
                                  style={{
                                    textAlign: "center",
                                    border: "1px solid #000",
                                  }}
                                  id="RO_BirthDateMonth"
                                >
                                  <InputField
                                    name="BirthDateMonth"
                                    format={value =>
                                      moment()
                                        .month(value - 1)
                                        .format("MMM")
                                    }
                                    {...data["BirthDateMonth"]}
                                    style={{ width: "40px", textAlign: "center" }}
                                  />
                                </td>
                                <td
                                  style={{
                                    textAlign: "center",
                                    border: "1px solid #000",
                                  }}
                                  id="RO_BirthDateYear"
                                >
                                  <InputField
                                    name="BirthDateYear"
                                    {...data["BirthDateYear"]}
                                    style={{ width: "40px", textAlign: "center" }}
                                  />
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
                <td
                  style={{
                    width: "25%",
                    borderRight: "1px solid #000",
                    paddingBottom: 5,
                    paddingRight: 20,
                  }}
                >
                  <table style={{ width: "100%" }}>
                    <tbody>
                      <tr>
                        <td style={{ paddingLeft: 10, width: 20 }}>h.</td>
                      </tr>
                      <tr>
                        <td style={{ paddingLeft: 10, paddingBottom: 5 }}>
                          <table style={{ width: "100%" }}>
                            <tbody>
                              <tr>
                                <td>Height</td>
                                <td>
                                  <InputField
                                    postfix="m"
                                    name="Height"
                                    {...data["Height"]}
                                    style={{ width: "50px", textAlign: "center" }}
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td>Weight</td>
                                <td>
                                  <InputField
                                    postfix="kg"
                                    name="Weight"
                                    {...data["Weight"]}
                                    style={{ width: "50px", textAlign: "center" }}
                                  />
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
                <td
                  style={{
                    width: "25%",
                    paddingBottom: 5,
                    paddingRight: 20,
                  }}
                >
                  <table style={{ width: "100%" }}>
                    <tbody>
                      <tr>
                        <td style={{ paddingLeft: 10, width: 20 }}>i.</td>
                        <td>Date Employed</td>
                      </tr>
                      <tr>
                        <td>&nbsp;</td>
                        <td style={{ paddingBottom: 5 }}>
                          <table
                            style={{
                              width: "100%",
                              border: "1px solid #000",
                              borderCollapse: "collapse",
                            }}
                          >
                            <tbody>
                              <tr>
                                <td
                                  style={{
                                    textAlign: "center",
                                    border: "1px solid #000",
                                  }}
                                >
                                  Day
                                </td>
                                <td
                                  style={{
                                    textAlign: "center",
                                    border: "1px solid #000",
                                  }}
                                >
                                  Month
                                </td>
                                <td
                                  style={{
                                    textAlign: "center",
                                    border: "1px solid #000",
                                  }}
                                >
                                  Year
                                </td>
                              </tr>
                              <tr>
                                <td
                                  style={{
                                    textAlign: "center",
                                    border: "1px solid #000",
                                  }}
                                  id="RO_JoinDateDay"
                                >
                                  <InputField
                                    name="JoinDateDay"
                                    {...data["JoinDateDay"]}
                                    style={{ width: "40px", textAlign: "center" }}
                                  />
                                </td>
                                <td
                                  style={{
                                    textAlign: "center",
                                    border: "1px solid #000",
                                  }}
                                  id="RO_JoinDateMonth"
                                >
                                  <InputField
                                    name="JoinDateMonth"
                                    format={value =>
                                      moment()
                                        .month(value - 1)
                                        .format("MMM")
                                    }
                                    {...data["JoinDateDay"]}
                                    style={{ width: "40px", textAlign: "center" }}
                                  />
                                </td>
                                <td
                                  style={{
                                    textAlign: "center",
                                    border: "1px solid #000",
                                  }}
                                  id="RO_JoinDateYear"
                                >
                                  <InputField
                                    name="JoinDateYear"
                                    {...data["JoinDateYear"]}
                                    style={{ width: "40px", textAlign: "center" }}
                                  />
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
    </tbody>
  </table>
);

Part1.propTypes = {
  data: PropTypes.shape({}),
};

export default Part1;



// WEBPACK FOOTER //
// ./components/employee/hdf_forms/Ge/GEHDMOREDEP2018/Part1.js